import { render, staticRenderFns } from "./approval-relativeList.vue?vue&type=template&id=03f6dcc5&scoped=true&"
import script from "./approval-relativeList.vue?vue&type=script&lang=js&"
export * from "./approval-relativeList.vue?vue&type=script&lang=js&"
import style0 from "./approval-relativeList.vue?vue&type=style&index=0&id=03f6dcc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f6dcc5",
  null
  
)

export default component.exports